/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home
    'home': {
      finalize: function() {
        //center password
        _eventAdd('resize', centerer, {init: false});
        _eventFire('resize', {init: false});
      }
    },
    // Home page
    'cases': {
      init: function() {
        //select filter fields
        var select = $('#category');
        select.selectOrDie({placeholder: "FILTER BY CATEGORY"});

                //select filter fields
        var select2 = $('#capability');
        select2.selectOrDie({placeholder: "FILTER BY Capability"});

      },
      finalize: function() {
        //center password
        _eventAdd('resize', centerer, {init: false});
        _eventFire('resize', {init: false});
      }
    },
    'single_cases': {
      init: function() {
        $('.fullscreen img').fullscreener();
        $('.venobox').venobox({
          framewidth: '80%',
          frameheight: '100%',
          closeColor: '#ffffff',
          bgcolor: 'none',
          closeBackground: 'none',
          cb_post_open: function(obj, gallIndex, thenext, theprev){
            if(obj.hasClass("brightcove-player")){
              $('.vbox-overlay .vbox-content').html(bc_inline_video_player_html[obj.attr("data-player-id")]);
              bc(document.getElementById(obj.attr("data-player-id")));
              init_videojs(obj.attr("data-player-id"));
              setTimeout(function(){
                window.dispatchEvent(new Event('resize'));
              }, 100);
            }
          }
        });

        $('.grid').on('click', function(){
          $.scrollTo('#cases', {duration: 500} );
        });
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

  function _eventAdd(event_name, handler, event_data){
    $(window).bind(event_name, event_data, handler);
  }

  function _eventFire(event_name, param){
    if(!param){ param = null; }
    $(window).triggerHandler(event_name, param);
  }

  function centerer(e, p){
    var init;
    if(this.centererEvent){ clearTimeout(this.centererEvent); }
    if(p){
      if(p.init === true){
        init = true;
      }else{
        init = false;
      }
    }else{
      init = false;
    }
    this.centererEvent = window.setTimeout(function(){
      $('.center_it').center(false, init);
    }, 100);
  }


  function align_cases(){
    $grid = $('#cases');
    if($grid.length > 0){
      $grid.imagesLoaded(function(){

        
          $('.category-select').fadeIn('200');
          $('#search-form').fadeIn('200');
          $('.capability-select').fadeIn('200');


          $grid.hide().fadeIn('200').isotope({
            itemSelector: '.block',
          });

      });
    }

    var select = $('#category');
    if(select.length > 0){
      select.on('change', function(){
        var option = ($(this).val() === '*') ? '*' : ('.' + $(this).val());
        $grid.isotope({ filter: option });
      });
    }

    var select2 = $('#capability');
    if(select2.length > 0){
      select2.on('change', function(){
        var option = ($(this).val() === '*') ? '*' : ('.' + $(this).val());
        $grid.isotope({ filter: option });
      });
    }

  }
  align_cases();




/**
 * Help functions for Brightcove video player
 */


  function init_videojs(player_id){
    var player = videojs(player_id);

    // VOLUME SETTINGS
    // check if default volume is set
    if($('#'+player_id).attr('data-volume')){
      player.volume($('#'+player_id).attr('data-volume'));
    }
    else {
      // volume change listener and cookie storage for persistence
      player.on('volumechange', function(){
        var volume = player.volume();
        if(player.muted()){
          volume = 0;
        }
        setCookieValue('video_sound_setting', volume, (86400*365));
      });
      // retrieve saved volume setting
      var saved_sound_setting = getCookieValue('video_sound_setting');
      if(saved_sound_setting===0){
        player.muted(true);
      }
      else if(saved_sound_setting > 0) {
        player.volume(saved_sound_setting);
      }
    }


    // LOOP
    if($('#'+player_id).attr('data-loop')){
      player.on("ended", function() {
        player.play();
      });
    }

    // AUTOPLAY
    if($('#'+player_id).attr('data-autoplay')){
      player.play();
    }


    bc_video_players[player_id] = player;


    return player;
  }





})(jQuery);

jQuery.fn.center = function(parent, init) {
    return this.each(function(){
      if (parent) {
          parent = jQuery(this).parent();
          parent.css({'position' : 'relative'});
      } else {
          parent = window;
      }

      var total_height = 0;
      jQuery(this).children().each(function(){
        total_height += jQuery(this).outerHeight(true);
      });

      jQuery(this).css({
          'position': 'absolute',
          'top': (((jQuery(parent).height() - total_height) / 2)),
          'width': '100%'
      });
      if(init){
        jQuery(this).hide().css({'opacity': 1}).fadeIn('200');
      }
  });
};
